<template>
  <div>
    <router-view></router-view>
    <Breadcrumb :items="breadcrumbs" />
    <div class="user__events">
      <EventsBanner
        :subtitle="`Latest Events`"
        :feat-img="
          featuredEvent.featuredImage != null
            ? featuredEvent.featuredImage
            : defaultImage
        "
        :feat-alt="featuredEvent.name"
        :title="featuredEvent.name"
        :excerpt="featuredEvent.description"
        :link-text="`Learn More`"
        :link-text-url="`${linkTextUrl + featuredEvent.id}`"
        v-if="featuredEvent"
      />
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="section-heading">Upcoming Events</h2>
          </div>
        </div>
        <div class="event-loader" v-if="isLoading">
          <Spinner class="loader-spinner" :theme="primary" :size="'large'" />
        </div>
        <template v-else>
          <div class="card__container row" v-if="events && events.length != 0">
            <Card
              v-for="(event, i) in events.slice(1)"
              :key="i"
              ref="card"
              :featured="
                event.featuredImage != null ? event.featuredImage : defaultImage
              "
              :featured-alt="event.name"
              :url="`${linkTextUrl + event.id}`"
            >
              <h5 class="card__subtitle">{{ event.subtitle }}</h5>
              <h3 class="card__title">{{ event.name }}</h3>
              <p class="card__excerpt" v-if="event.description">
                {{ event.description | decode | limit }}
              </p>
              <router-link
                tag="a"
                :to="linkTextUrl + event.id"
                :style="{ color: scheme.primary }"
                class="card__cta"
                >{{ `Learn More` }}</router-link
              >
            </Card>
          </div>
          <div v-else>
            No Result Found
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
const EventsBanner = () => import("@/modules/user/elements/EventsBanner");
const Card = () => import("@/modules/user/elements/Card");
const Breadcrumb = () => import("@/components/Breadcrumb");
const Spinner = () => import("@/components/Spinner");

export default {
  name: "user-events",
  components: {
    Breadcrumb,
    EventsBanner,
    Card,
    Spinner
  },
  data: () => ({
    subtitle: "",
    featImg: "",
    featAlt: "",
    title: "",
    excerpt: "",
    linkTextUrl: "events/",
    defaultImage: require("@/assets/media/backgrounds/default.jpg"),
    breadcrumbs: [
      { path: "/user", name: "Home" },
      { path: "", name: "Events" }
    ],
    featuredEvent: null,
    isLoading: true
  }),
  computed: {
    events() {
      return this.$store.state.concierge.eventsList.data;
    },
    scheme() {
      return this.$store.state.app.scheme;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    }
  },
  mounted() {},
  watch: {
    events: function(val) {
      if (val) {
        this.featuredEvent = val[0];
      }
      if (this.featuredEvent) {
        this.$nextTick(() => {
          const { card } = this.$refs;
          const el = [];

          if (card) {
            card.map(e => {
              el.push(e.$el.children[0].offsetHeight);
            });

            const max = Math.max(...el);

            card.map(e => {
              e.$el.children[0].style.minHeight = `${max}px`;
            });
          }
        });
      }
    }
  },
  async created() {
    await this.$store.dispatch("fetchEvents");
    this.isLoading = false;
  }
};
</script>

<style lang="scss" scoped>
h2 {
  color: $gray-900;
  font-family: $headings-font-family;
  font-size: $font-size-md;
  font-weight: 500;
}
.event-loader {
  padding-left: 2rem;
}
</style>
